import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "as-statics" }
const _hoisted_2 = { class: "as-statics-item as__overview" }
const _hoisted_3 = { class: "as-statics-item as__home" }
const _hoisted_4 = { class: "as-statics-item as__away" }

import { computed } from 'vue';
    import type { IFootyStats, ITeam, IStatsParent } from '~src/interfaces/footystats';

    
const __default__ = {};

interface Props {
        footyStats: IFootyStats | null;
        teamMode?: string
        homeTeamInfo: ITeam | null;
        awayTeamInfo: ITeam | null;
    }

    
export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'StaticsTeam',
  props: {
    footyStats: { default: null },
    teamMode: { default: 'home' },
    homeTeamInfo: {},
    awayTeamInfo: {}
  },
  setup(__props: any) {

    const props = __props

    const homeTeamLastX = computed<IStatsParent>(() => {
        return props.footyStats?.home_team_last_x ?? ({} as IStatsParent);
    });

    const awayTeamLastX = computed<IStatsParent>(() => {
        return props.footyStats?.away_team_last_x ?? ({} as IStatsParent);
    });

    const getValueWithMode = (team = 'home', mode = 'btts') => {
        const __data: IStatsParent = team === "home" ? homeTeamLastX.value : awayTeamLastX.value;

        let __mode = mode
        if (!__data || !__data.stats || !__data.stats.hasOwnProperty(__mode)) {
            return 0;
        }

        return __data.stats[__mode];
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"as-statics-item as__title\"><div>Thống kê</div><div>Thắng %</div><div>Trung bình</div><div>Đã ghi bàn</div><div>Bị thủng lưới</div><div>BTTS</div><div>Giữ sạch lưới</div><div>FTS</div><div>xG</div><div>xG chống lại</div></div>", 1)),
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", null, "Tổng quan", -1)),
      _createElementVNode("div", null, _toDisplayString(getValueWithMode(_ctx.teamMode, 'winPercentage_overall')) + "% ", 1),
      _createElementVNode("div", null, _toDisplayString(getValueWithMode(_ctx.teamMode, 'seasonAVG_overall')), 1),
      _createElementVNode("div", null, _toDisplayString(getValueWithMode(_ctx.teamMode, 'seasonScoredAVG_overall')), 1),
      _createElementVNode("div", null, _toDisplayString(getValueWithMode(_ctx.teamMode, 'seasonConcededAVG_overall')), 1),
      _createElementVNode("div", null, _toDisplayString(getValueWithMode(_ctx.teamMode, 'seasonBTTSPercentage_overall')) + "% ", 1),
      _createElementVNode("div", null, _toDisplayString(getValueWithMode(_ctx.teamMode, 'seasonCSPercentage_overall')) + "% ", 1),
      _createElementVNode("div", null, _toDisplayString(getValueWithMode(_ctx.teamMode, 'seasonFTSPercentage_overall')) + "% ", 1),
      _createElementVNode("div", null, _toDisplayString(getValueWithMode(_ctx.teamMode, 'xg_for_avg_overall')), 1),
      _createElementVNode("div", null, _toDisplayString(getValueWithMode(_ctx.teamMode, 'xg_against_avg_overall')), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _cache[1] || (_cache[1] = _createElementVNode("div", null, "Đội nhà", -1)),
      _createElementVNode("div", null, _toDisplayString(getValueWithMode(_ctx.teamMode, 'winPercentage_home')) + "% ", 1),
      _createElementVNode("div", null, _toDisplayString(getValueWithMode(_ctx.teamMode, 'seasonAVG_home')), 1),
      _createElementVNode("div", null, _toDisplayString(getValueWithMode(_ctx.teamMode, 'seasonScoredAVG_home')), 1),
      _createElementVNode("div", null, _toDisplayString(getValueWithMode(_ctx.teamMode, 'seasonConcededAVG_home')), 1),
      _createElementVNode("div", null, _toDisplayString(getValueWithMode(_ctx.teamMode, 'seasonBTTSPercentage_home')) + "% ", 1),
      _createElementVNode("div", null, _toDisplayString(getValueWithMode(_ctx.teamMode, 'seasonCSPercentage_home')) + "% ", 1),
      _createElementVNode("div", null, _toDisplayString(getValueWithMode(_ctx.teamMode, 'seasonFTSPercentageHT_home')) + "% ", 1),
      _createElementVNode("div", null, _toDisplayString(getValueWithMode(_ctx.teamMode, 'xg_for_avg_home')), 1),
      _createElementVNode("div", null, _toDisplayString(getValueWithMode(_ctx.teamMode, 'xg_against_avg_home')), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[2] || (_cache[2] = _createElementVNode("div", null, "Đội khách", -1)),
      _createElementVNode("div", null, _toDisplayString(getValueWithMode(_ctx.teamMode, 'winPercentage_away')) + "% ", 1),
      _createElementVNode("div", null, _toDisplayString(getValueWithMode(_ctx.teamMode, 'seasonAVG_away')), 1),
      _createElementVNode("div", null, _toDisplayString(getValueWithMode(_ctx.teamMode, 'seasonScoredAVG_away')), 1),
      _createElementVNode("div", null, _toDisplayString(getValueWithMode(_ctx.teamMode, 'seasonConcededAVG_away')), 1),
      _createElementVNode("div", null, _toDisplayString(getValueWithMode(_ctx.teamMode, 'seasonBTTSPercentage_away')) + "% ", 1),
      _createElementVNode("div", null, _toDisplayString(getValueWithMode(_ctx.teamMode, 'seasonCSPercentage_away')) + "% ", 1),
      _createElementVNode("div", null, _toDisplayString(getValueWithMode(_ctx.teamMode, 'seasonFTSPercentageHT_away')) + "% ", 1),
      _createElementVNode("div", null, _toDisplayString(getValueWithMode(_ctx.teamMode, 'xg_for_avg_away')), 1),
      _createElementVNode("div", null, _toDisplayString(getValueWithMode(_ctx.teamMode, 'xg_against_avg_away')), 1)
    ])
  ]))
}
}

})